export function SectionHeader({ eyebrow, title, description, align = "left", className = "" }) {
  return (
    <div className={`${align === "center" ? "text-center" : ""} ${className}`}>
      {eyebrow && (
        <p
          className="text-xs font-semibold tracking-[0.14em] uppercase text-[hsl(41,47%,61%)] mb-3"
          style={{ fontFamily: 'var(--font-display)' }}
        >
          {eyebrow}
        </p>
      )}
      <h2
        className="text-2xl sm:text-3xl font-semibold tracking-tight text-foreground"
        style={{ fontFamily: 'var(--font-display)' }}
      >
        {title}
      </h2>
      {description && (
        <p className={`mt-3 text-sm sm:text-base leading-relaxed text-muted-foreground max-w-2xl ${align === "center" ? "mx-auto" : ""}`}>
          {description}
        </p>
      )}
    </div>
  );
}
